import { render, staticRenderFns } from "./DonationSuccessModal.vue?vue&type=template&id=f32498fc"
import script from "./DonationSuccessModal.vue?vue&type=script&lang=ts"
export * from "./DonationSuccessModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports